// extracted by mini-css-extract-plugin
export var frame = "cv-module--frame--X2-S2";